import Immutable from 'seamless-immutable';

export const modalSelector = state => Immutable.asMutable(state.modal, {deep: true});
